import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import Spacer from 'components/Spacer';

import AddNewBlock from './add-new-block';
import Block from './survey-block';
import SurveyHeader from './survey-header';
import { getSerializedBlocks } from './utils';

type BuilderProps = {
  imageRef: any;
  accountInfo: any;
  setSurveyForm: any;
};

const SurveyQuestionsBuilder = ({
  imageRef,
  accountInfo,
  setSurveyForm,
}: BuilderProps) => {
  const { getValues, watch, control, setValue } = useFormContext();
  const [open, setOpen] = useState(0);

  const surveyForm = getValues();

  const watchQuestions = watch(`question_details.questions`);

  const { blocks, allBlocks, thankyouBlock } =
    getSerializedBlocks(watchQuestions);

  // console.log('watchQuestions', watchQuestions, allBlocks)

  return (
    <div className="questions-builder">
      {accountInfo ? (
        <SurveyHeader imageRef={imageRef} surveyForm={surveyForm} />
      ) : null}

      <div className="builder-container">
        {allBlocks &&
          allBlocks.map((block: any, index: number) => (
            <Block
              key={block.name}
              block={block}
              disabled={surveyForm.state === 'ACTIVE'}
              open={open === index}
              setOpen={() => setOpen(index)}
              surveyForm={surveyForm}
              blocks={blocks}
              setSurveyForm={setSurveyForm}
            />
          ))}
      </div>
      <AddNewBlock
        allBlocks={allBlocks}
        setOpen={setOpen}
        disabled={surveyForm.state === 'ACTIVE'}
        surveyForm={surveyForm}
        setSurveyForm={setSurveyForm}
      />
      <Spacer y={1} />

      <div className="builder-footer">
        <Block
          block={thankyouBlock}
          blocks={blocks}
          open={open === -1}
          setOpen={() => setOpen(-1)}
          surveyForm={surveyForm}
          setSurveyForm={setSurveyForm}
          disabled={surveyForm.state === 'ACTIVE'}
          thankYouMessage={true}
        />
      </div>
      {/* <pre>{JSON.stringify(surveyForm, null, 2)}</pre> */}
    </div>
  );
};

export default SurveyQuestionsBuilder;
